'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 7,
    bottom: 50,
    left: 90,
    right: 10
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 6,
    yAxisShift: 0,
    yAxisLabelShift: 70
  };
};
module.exports = Params;